var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticStyle:{"margin":"0 0.25rem"},on:{"click":_vm.changeLanguage}},[_c('img',{staticStyle:{"height":"40px"},style:(_vm.$i18n.locale === _vm.language ? _vm.activeStyle : _vm.inactiveStyle),attrs:{"alt":`${_vm.language}-flag`,"src":`/images/languages/${_vm.language}.png`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }